export const lecturesApi = {
  lectures: {
    queryKey: (params?: string[]) => ["lectures", ...(params || [])],
    route: () => `lectures`,
    methods: ["GET", "POST"],
  },
  lecture: {
    queryKey: (id: number, params?: string[]) => [
      "lectures",
      id,
      ...(params || []),
    ],
    route: (id: number) => `lectures/${id}`,
    methods: ["PATCH", "DELETE"],
  },
};
